import { cx, Icon, type IconName } from "@/components/ui";

const CLUSTER: { icon: IconName; size: number; tile: string; tone: string }[] = [
  { icon: "grid", size: 52, tile: "bg-[#d9f0e6]", tone: "text-[#12a97e]" },
  { icon: "zap", size: 60, tile: "bg-brand-100", tone: "text-brand-500" },
  { icon: "globe", size: 52, tile: "bg-[#fce7c6]", tone: "text-[#d07100]" },
];

/** The three overlapping icon discs above the "unavailable" and "coming soon" cards. */
export function IconCluster() {
  return (
    <div aria-hidden className="flex items-center justify-center">
      {CLUSTER.map((c, i) => (
        <span
          key={c.icon}
          style={{ width: c.size, height: c.size }}
          className={cx(
            "flex items-center justify-center rounded-full border-3 border-white",
            c.tile,
            c.tone,
            i < CLUSTER.length - 1 && "-mr-2.5",
          )}
        >
          <Icon name={c.icon} size={c.size * 0.42} />
        </span>
      ))}
    </div>
  );
}
